// 現在のキャンバスと同じ ID をルーム ID に使うプランニングポーカーのルーム URL を構築する。
// Connect Canvas で整理した内容をそのまま同じ参加者で見積もれるよう、
// キャンバス ID をルーム ID として引き継ぎ、追加の採番や問い合わせを行わない。
import { isValidCanvasId } from "./canvas-id";

/**
 * 自サービス origin からプランニングポーカーの origin を導出する。
 * ホスト名先頭の `refinement.` を `lpp.` に置換し、demo / prod を必ず同じ環境へ揃える。
 */
export function getPlanningPokerOrigin(
  serviceOrigin: string | undefined
): string | null {
  const service = validateHttpOrigin(serviceOrigin);
  if (service === null) {
    return null;
  }
  const url = new URL(service);
  if (!url.hostname.startsWith("refinement.")) {
    return null;
  }
  url.hostname = `lpp.${url.hostname.slice("refinement.".length)}`;
  return url.origin;
}

/**
 * 同じキャンバス ID をルーム ID に使うプランニングポーカーのルーム URL を構築する。
 * プランニングポーカー側は未知のルーム ID でも接続時にルームを遅延作成するため、
 * Connect Canvas からルーム作成 API を呼ばない。
 */
export function buildPlanningPokerRoomUrl(
  canvasId: string,
  serviceOrigin: string | undefined
): string | null {
  if (!isValidCanvasId(canvasId)) {
    return null;
  }
  const origin = getPlanningPokerOrigin(serviceOrigin);
  if (origin === null) {
    return null;
  }
  // ルーム ID は遷移元のキャンバス ID をそのまま使い、クエリや fragment は付けない。
  return new URL(`/room/${encodeURIComponent(canvasId)}`, origin).toString();
}

function validateHttpOrigin(value: string | undefined): string | null {
  if (value === undefined || value.trim().length === 0) {
    return null;
  }
  try {
    const url = new URL(value.trim());
    if (url.protocol !== "http:" && url.protocol !== "https:") {
      return null;
    }
    return url.origin;
  } catch {
    return null;
  }
}
